import { fetchFinance, fetchOnlinePay, fetchOperation } from "utils/api";

export const sendReceiptFormOnline = async (params) => {
  return await fetchOnlinePay("/transaction/action", {
    transactionType: "RECEIPT",
    ...params,
  });
};

export const sendReceiptFormOffline = async (params) => {
  return await fetchOperation("/transaction/action", {
    receiptType: "EMAIL",
    transactionType: "RECEIPT",
    ...params,
  });
};

export const voidTransactionFormOffline = async (params) => {
  return await fetchOperation("/transaction/action", {
    ...params,
  });
};

export const getTransactionRefundableOffline = async (params) => {
  return await fetchFinance("/action", {
    method: "post",
    action: "getRefundable",
    ...params,
  });
};

export const refundTransactionOffline = async (params) => {
  return await fetchOperation("/transaction/action", {
    transactionType: "SALE_REFUND",
    ...params,
  });
};

export const voidTransactionFormOnline = async (params) => {
  return await fetchOnlinePay("/transaction/action", {
    transactionType: "VOID",
    ...params,
  });
};

export const getTransactionRefundableOnline = async (params) => {
  return await fetchFinance("/action", {
    method: "post",
    action: "getRefundable",
    ...params,
  });
};

export const refundTransactionOnline = async (params) => {
  return await fetchOnlinePay("/transaction/action", {
    transactionType: "REFUND",
    ...params,
  });
};
